import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface OcrAttachmentEntry {
  attachmentId: number;
  pageNumberRange?: string;
}

export interface RunOcrScanRequest {
  companyId: number;
  attachments: OcrAttachmentEntry[];
}

const useRunOcrScanApi = () => {
  const call = useCallback(
    (requestBody?: RunOcrScanRequest) =>
      new Promise((resolve, reject) => {
        axiosInstance
          .post(api.runOcrScan(), requestBody)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    ocrScanRun: execute,
    isOcrScanRunning: isLoading,
  };
};

export default useRunOcrScanApi;
